import React from 'react';
import { twMerge } from 'tailwind-merge';

interface HeadlineProps {
  colorful?: boolean;
  className?: string;
  children: React.ReactNode;
}

export function Heading({
  children,
  className,
  colorful = false,
}: HeadlineProps) {
  const gradiend = colorful
    ? 'text-transparent bg-clip-text bg-gradient-to-br from-[#FFFFFF] from-30% to-[#FFFFFF]/40 to-100% w-fit'
    : '';
  const classNames = twMerge(
    'fontMontserrat text-white text-5xl leading-10 leading-snug font-bold -tracking-[.1rem]',
    className,
    gradiend
  );
  return <div className={classNames}>{children}</div>;
}

interface SubheadlineProps {
  className?: string;
  children: React.ReactNode;
}

export function HeadingSubline({ children, className }: SubheadlineProps) {
  const classNames = twMerge(
    'fontMontserrat text-white text-sm opacity-50',
    className
  );
  return <div className={classNames}>{children}</div>;
}

interface ParagraphProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * @deprecated use multi-lib/staoui/Typography instead
 */
export function Paragraph({ children, className }: ParagraphProps) {
  const classNames = twMerge('fontMontserrat text-white text-lg', className);
  return <p className={classNames}>{children}</p>;
}

// eslint-disable-next-line import/no-default-export
export default Paragraph;
